import React from 'react';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import '../App.css';

const jobOpenings = [
    {
        id: 1,
        title: 'Marine Engineer',
        location: 'Colombo, Sri Lanka',
        type: 'Full-time',
        description:
            'Responsible for vessel maintenance, troubleshooting, and compliance with international safety standards.',
        link: 'marine-engineer'
    },
    {
        id: 2,
        title: 'Technical Superintendent',
        location: 'Dubai, UAE',
        type: 'Full-time',
        description:
            'Oversee vessel performance, maintenance schedules, dry-docking, and manage onboard crew technical operations.',
        link: 'technical-superintendent'
    },
    {
        id: 3,
        title: 'Marketing Executive',
        location: 'Colombo, Sri Lanka',
        type: 'Full-time',
        description:
            'We are looking for a talented Marketing Executive to undertake marketing projects for the benefit of our company. You will organize creative campaigns and promotional events that can make a difference for our company’s success.',
        link: 'marketing-executive'
    }
];

const Career = () => {
    return (
        <div>
            <div className="career-page">
                {/* Hero */}
                <section className="career-hero">
                    <div className="career-hero-text">
                        <h1>Careers at Blue Waves</h1>
                        <p>Join a team that powers global maritime excellence.</p>
                    </div>
                </section>

                {/* Culture Section */}
                <section className="career-culture">
                    <h2>🌊 Why Work With Us?</h2>
                    <p>
                        At Blue Waves, we believe in fostering a culture of excellence, innovation, and safety. Whether onshore or at sea, our team is united by a shared commitment to integrity, responsibility, and continuous growth.
                    </p>
                    <ul className="culture-values">
                        <li>⚓ Professional growth & learning</li>
                        <li>🌍 Diverse global operations</li>
                        <li>🛟 Safety-first environment</li>
                        <li>🧭 Empowering leadership</li>
                    </ul>
                </section>

                {/* Open Positions */}
                <section className="career-jobs">
                    <h2>🚢 Current Job Openings</h2>
                    <div className="career-job-list">
                        {jobOpenings.map((job, index) => (
                            <div key={index} className="career-job-card">
                                <h3>{job.title}</h3>
                                <p><strong>Location:</strong> {job.location}</p>
                                <p><strong>Type:</strong> {job.type}</p>
                                <p className="job-desc">{job.description}</p>
                                <Link to={`/apply/${job.link}`} className="apply-button">
                                    Apply Now
                                </Link>
                            </div>
                        ))}
                    </div>
                </section>

                {/* CTA */}
                <section className="career-cta">
                    <h2>Didn't find the right role?</h2>
                    <p>We’re always on the lookout for passionate individuals. Send your resume to <a href="mailto:info@bluewavesshipmanagement.com"> info@bluewavesshipmanagement.com</a> and we’ll get in touch if there’s a match.</p>
                </section>
            </div>
            <Footer />
        </div>
    );
};

export default Career;
